// Tooltip descriptions for all testing options
// Edit the descriptions here to change what appears in the tooltips

export default {
  // Main Testing Suites
  production_suite: "ABV, Calories, Real + Apparent Extract, OG + FG, Real + Apparent Fermentation",
  
  alcolyzer_selzer: "ABV, Calories, Real + Apparent Extract, OG + FG, Real + Apparent Fermentation, IBU, pH, SRM",
  
  simple_nutrition: "Production Suite with Carbohydrates, Protein, Sodium. Sugar",
  
  // Chemistry Tests
  chemistry__acetic_acid: "Measures acetic acid levels to detect bacterial contamination and off-flavors. Critical for quality control in sour beers and detecting spoilage",
  
  chemistry__lactic_acid: "Quantifies lactic acid concentration from fermentation. Important for sour beer production and detecting lactobacillus contamination",
  
  chemistry__sulfur_dioxide: "Measures free and total SO2 levels. Used as preservative and antioxidant, important for shelf stability",
  
  chemistry__free_amino_nitrogen: "Measures available nitrogen for yeast health. Critical for fermentation performance and avoiding stuck fermentations",
  
  chemistry__vicinal_diketones: "Tests for vicinal diketones including diacetyl and 2,3-pentanedione. Detects buttery/butterscotch off-flavors",
  
  chemistry__acetaldehyde: "Measures green apple off-flavor compounds. Indicates incomplete fermentation or yeast stress",
  
  simple_nutrition__polyphenols: "Measures antioxidant compounds affecting flavor stability, haze formation, and mouthfeel",
  
  simple_nutrition__starch: "Detects residual starch indicating incomplete conversion. Critical for preventing haze and ensuring fermentation efficiency",
  
  // Micro Services - PCR Testing
  microservices__pcr_bacteria_analysis: "General Lactobacillus and Pediococcus, acetic acid producing bacteria (Acetobacter, Gluconobacter, Asaia, Legionella), Megasphaera/Pectinatus, Hor A/B/C hop resistant lactic acid bacterias",
  
  microservices__pcr_yeast_analysis: "Saccharomyces cerevisiae, Saccharomyces cerevisiae var. diastaticus, Saccharomyces pastorianus, Brettanomyces bruxellensis / claussenii / naardenensis / nanus / custersiananus",
  
  // Pathogen Testing
  microservices__pasteurization_analysis: "E. coli + coliforms, Listeria, Salmonella testing",
  
  // Plating Services
  microservices__plate_analysis: "Duplicate on single media, aerobic and anaerobic",
  
  microservices__pcr_and_plate_analysis: "LCSM, WLD (aerobic + anaerobic), WLN. Including gram stain if necessary with colony consistent with common spoilers",
  
  // Spoiler Micro Testing
  microservices__spoiler_micro_simple: "Testing suite for typical spoilers. WLN (aerobic + anaerobic) plating, yeast qPCR, bacteria qPCR",
  
  microservices__spoiler_micro_comprehensive: "Testing suite for typical spoilers across multiple media and tests. LCSM, WLD (aerobic and anaerobic), WLN plating, qPCR yeast, qPCR bacteria, pathogen profile",
  
  // Pasteurization Validation
  microservices__pasteurization_validation_simple: "Includes Process Authority letter for audits. Production Suite+, WLN (aerobic + anaerobic) plating, qPCR yeast, qPCR bacteria, pathogen profile",
  
  microservices__pasteurization_validation_comprehensive: "Includes Process Authority letter for audits. Production Suite+, LCSM, WLD, WLN (aerobic + anaerobic) plating, qPCR yeast, qPCR bacteria, pathogen profile",
  
  // Shelf Life Analysis
  microservices__shelf_life_analysis: "Shelf Life Analysis - Standard shelf life testing with periodic sampling to determine product stability over time.",
  
  microservices__shelf_life_analysis_simple: "Testing done at 0, 30, 60, 120 days to evaluate if pasteurization was effective against more resilient microbes. WLN (aerobic + anaerobic) plating, fermentation metrics, pH, color",
  
  microservices__shelf_life_analysis_comprehensive: "Testing done at 0, 30, 60, 120 days to evaluate if pasteurization was effective against more resilient microbes. LCSM, WLD, WLN (aerobic + anaerobic) plating, fermentation metrics, pH, color",
  
  // Gas Analysis
  o2_co2_testing: "Dissolved O2 + CO2 on-site and packaging testing with Anton-Paar CBOX QC + PDF piercer",
  
  // CBD/THC Testing
  cbd_thc_potency: "Cannabinoid potency (THC/CBD). Meets regulatory requirements for hemp-derived beverages.",
  
  cbd_thc_potency_plus: "Cannabinoid potency (THC/CBD) packaged w/Basic Suite. Meets regulatory requirements for hemp-derived beverages",
  
  cbd_thc_potency_plus_plus: "Cannabinoid potency (THC/CBD)packaged w/Production Suite. Meets regulatory requirements for hemp-derived beverages",
  
  // Water Chemistry
  water_chemistry: "Calcium, Magnesium, Bicarbonate, Chloride, Potassium, Sulfate, Zinc, pH",
  
  water_chemistry_plus: "Water Chemistry with Sodium, Total Chlorine, Alkalinity"
};
